// ========================================================================================================== SECTION 1
// DESKTOP
coMM.add("(min-width: 750px)", () => {
  gsap.set('.co-regen-section-1-image-frame-1', { opacity: 0, scale: 1.2 });
  gsap.set('.co-regen-section-1-image-title-frame-1', { opacity: 0, scale: 1.5 });
  let coRegenSection1Timeline = gsap.timeline();
  coRegenSection1Timeline.to('.co-regen-section-1-image-frame-1', {
    scale: 1,
    opacity: 1,
    ease: "power2.inOut",
    duration: 1
  });
  coRegenSection1Timeline.to('.co-regen-section-1-image-title-frame-1', {
    scale: 1,
    opacity: 1,
    ease: "power2.inOut",
    duration: 1
  }, "-=0.9");
  // SCRUB
  gsap.set('.co-regen-section-1-image-frame-2', { clipPath: "circle(calc(50% - 122.5px) at 50% calc(50% + 40px))" });
  gsap.to('.co-regen-section-1-image-frame-2', {
    scrollTrigger: {
      // markers: true,
      trigger: '.co-regen-section-1',
      start: "top top",
      end: "50% top",
      scrub: 1
    },
    clipPath: "circle(calc(120% - 0px) at 50% calc(50% + 0px))"
  });
})
// MOBILE
coMM.add("(max-width: 749px)", () => {
  gsap.set('.co-regen-section-1-image-frame-1', { opacity: 0, scale: 0.9 });
  gsap.to('.co-regen-section-1-image-frame-1', {
    scale: 1,
    opacity: 1,
    ease: "power2.inOut",
    duration: 1
  });
  // SCRUB
  gsap.set('.co-regen-section-1-image-frame-2', { clipPath: "circle(45% at 50% 50%)" });
  gsap.to('.co-regen-section-1-image-frame-2', {
    scrollTrigger: {
      // markers: true,
      trigger: 'body',
      endTrigger: '.co-regen-section-1-content-frame',
      start: "top top",
      end: "top top",
      scrub: 1
    },
    clipPath: "circle(100% at 50% 50%)"
  });
})
// SCRUB
gsap.set('.co-regen-section-1-image-frame-4 img', { top: "-10%" });
gsap.to('.co-regen-section-1-image-frame-4 img', {
  scrollTrigger: {
    // markers: true,
    trigger: '.co-regen-section-1',
    start: "top top",
    end: "bottom top",
    scrub: 1
  },
  top: "10%"
});
// TITLE
gsap.to('.co-regen-section-1-image-title img', {
  scrollTrigger: {
    // markers: true,
    trigger: 'body',
    endTrigger: '.co-regen-section-1',
    start: "top top",
    end: "33% top",
    scrub: 1
  },
  yPercent: -100,
  scale: 1.5,
  opacity: 0
});
// ========================================================================================================== SECTION 2
if (!document.documentElement.classList.contains('shopify-design-mode')) {
  // ===================================================== PIN
  document.querySelectorAll('.co-regen-section-2-pinned').forEach((slide, i) => {
    ScrollTrigger.create({
      // markers: true,
      trigger: slide,
      start: "top top",
      pinSpacing: false,
      end: () => `+=${slide.offsetHeight}`,
      pin: true
    });
  });
  // ===================================================== SLIDER TITLE FADE IN
  gsap.to('.co-regen-section-2-text-overlay-frame', {
    scrollTrigger: {
      // markers: true,
      trigger: '.co-regen-section-2',
      start: "top top",
      end: "10% top",
      scrub: 1
    },
    opacity: 1
  });
  // ===================================================== SLIDER TITLE FADE OUT
  gsap.to('.co-regen-section-2-text-overlay', {
    scrollTrigger: {
      // markers: true,
      trigger: '.co-regen-section-2',
      start: "95% bottom",
      end: "bottom+=15% bottom",
      scrub: 1
    },
    opacity: 0
  });
  // ===================================================== SECTION SLIDE UP ON SECTION 3
  gsap.to('.co-regen-section-2-slider-wrapper', {
    scrollTrigger: {
      // markers: true,
      trigger: '.co-regen-section-3',
      start: "top bottom",
      end: "bottom top",
      scrub: 1
    },
    yPercent: -50
  });
  // ===================================================== DESKTOP
  coMM.add("(min-width: 750px)", () => {
    // ===================================================== SLIDER SCRUB
    gsap.to('.co-regen-section-2-slider', {
      scrollTrigger: {
        // markers: true,
        trigger: '.co-regen-section-2',
        start: "top 15%",
        end: "bottom+=25% bottom",
        scrub: 1
      },
      x: "-60vw"
    });
    // ===================================================== SLIDER TITLE FADE
    gsap.to('.co-regen-section-2-text-overlay-frame', {
      scrollTrigger: {
        // markers: true,
        trigger: '.co-regen-section-2',
        start: "95% bottom",
        end: "bottom+=15% bottom",
        scrub: 1
      },
      yPercent: -10
    });
  });
  coMM.add("(max-width: 749px)", () => {
    // ===================================================== SLIDER SCRUB
    gsap.to('.co-regen-section-2-slider', {
      scrollTrigger: {
        // markers: true,
        trigger: '.co-regen-section-2',
        start: "top 15%",
        end: "bottom+=25% bottom",
        scrub: 1
      },
      x: "-160vw"
    });
  });
}
// ========================================================================================================== SECTION 3
if (!document.documentElement.classList.contains('shopify-design-mode')) {
  // ===================================================== PIN
  coMM.add("(min-width: 750px)", () => {
    ScrollTrigger.create({
      // markers: true,
      trigger: ".co-regen-section-3-frame",
      endTrigger: ".co-regen-section-3-slide-2-frame-2",
      pin: ".co-regen-section-3-slide-1-frame-1",
      start: "top top",
      end: "top top"
    });
    gsap.set('.co-regen-section-3-frame', { y: 100 });
    gsap.to('.co-regen-section-3-frame', {
      scrollTrigger: {
        // markers: true,
        trigger: '.co-regen-section-3-main-title-frame',
        endTrigger: '.co-regen-section-4-slide-1',
        start: "bottom top",
        end: "bottom bottom",
        scrub: 1
      },
      y: 0
    });
  });
}

gsap.set(".co-regen-section-3-image-left-img-1", { xPercent: -2, yPercent: -2, scale: 1, opacity: 1 });
gsap.set(".co-regen-section-3-image-left-img-2", { xPercent: 2, yPercent: -2, scale: 1, opacity: 1 });
gsap.set(".co-regen-section-3-image-left-img-3", { xPercent: 2, yPercent: 2, scale: 1, opacity: 1 });
gsap.set(".co-regen-section-3-image-left-img-4", { xPercent: -2, yPercent: 2, scale: 1, opacity: 1 });
gsap.to('.co-regen-section-3-image-left-frame-1>div', {
  scrollTrigger: {
    // markers: true,
    trigger: ".co-regen-section-3-slide-1",
    start: "top bottom",
    end: "120% top",
    scrub: 1
  },
  xPercent: 0,
  yPercent: 0,
  scale: 1,
  opacity: 1,
  duration: 1
})

gsap.set(".co-regen-section-3-image-right-img-1", { xPercent: -2, yPercent: -2, scale: 1, opacity: 1 });
gsap.set(".co-regen-section-3-image-right-img-2", { xPercent: 2, yPercent: -2, scale: 1, opacity: 1 });
gsap.set(".co-regen-section-3-image-right-img-3", { xPercent: 2, yPercent: 2, scale: 1, opacity: 1 });
gsap.set(".co-regen-section-3-image-right-img-4", { xPercent: -2, yPercent: 2, scale: 1, opacity: 1 });
gsap.to('.co-regen-section-3-image-right-frame-1>div', {
  scrollTrigger: {
    // markers: true,
    trigger: ".co-regen-section-3-slide-2",
    start: "50% bottom",
    end: "100% top",
    scrub: 1
  },
  xPercent: 0,
  yPercent: 0,
  scale: 1,
  opacity: 1,
  duration: 1
})
// ========================================================================================================== SECTION 4
if (!document.documentElement.classList.contains('shopify-design-mode')) {
  // ===================================================== PIN
  document.querySelectorAll('.co-regen-section-4-slide').forEach((slide, i) => {
    ScrollTrigger.create({
      // markers: true,
      trigger: slide,
      start: "bottom bottom",
      end: "bottom top",
      pinSpacing: false,
      pin: true
    });
  });
  // ===================================================== SLIDE OUT
  document.querySelectorAll('.co-regen-section-4-slide-frame-1').forEach((slide, i) => {
    gsap.to(slide, {
      scrollTrigger: {
        // markers: true,
        trigger: slide,
        start: "bottom bottom",
        end: "bottom top",
        scrub: 1
      },
      scale: 0.5,
      opacity: 0
    });
  });
  // ===================================================== SLIDE BORDER
  document.querySelectorAll('.co-regen-section-4-slide-frame-2').forEach((slide, i) => {
    gsap.to(slide, {
      scrollTrigger: {
        // markers: true,
        toggleActions: "play none none reverse",
        trigger: slide,
        start: "bottom bottom",
        end: "bottom bottom"
      },
      borderRadius: "10px",
      duration: 0.5
    });
  });
}
// ========================================================================================================== SECTION 5
if (!document.documentElement.classList.contains('shopify-design-mode')) {
  console.log("regen");
}
// ===================================================== FLICKITY
new Flickity( '.co-regen-section-5-slider-2', {
    prevNextButtons: false, 
    pageDots: false, 
    // wrapAround: true,
    // autoPlay: 5000,
    on: {
      ready: function() {

      }
    }
  });
new Flickity( '.co-regen-section-5-slider-1', {
    asNavFor: ".co-regen-section-5-slider-2", 
    // contain: true, 
    cellAlign: "left", 
    pageDots: false, 
    prevNextButtons: false, 
    // wrapAround: true,
    draggable: false,
    on: {
      ready: function() {

      }
    }
  });
// ========================================================================================================== SECTION 6
gsap.set('.co-regen-section-6-left-img>a', { scale: 0.25, opacity: 0 });
gsap.to('.co-regen-section-6-left-img>a', {
  scrollTrigger: {
    trigger: '.co-regen-section-6-left',
    start: "25% bottom",
    end: "bottom bottom",
  },
  scale: 1,
  opacity: 1,
  ease: "power2.inOut",
  duration: 0.75,
  stagger: 0.05
});
gsap.set('.co-regen-section-6-right-img>div', { scale: 0.25, opacity: 0 });
gsap.to('.co-regen-section-6-right-img>div', {
  scrollTrigger: {
    trigger: '.co-regen-section-6-right',
    start: "25% bottom",
    end: "bottom bottom",
  },
  scale: 1,
  opacity: 1,
  ease: "power2.inOut",
  duration: 0.5,
  stagger: 0.05
});
// HOVER
function applyHoverEffect(selector, hoverClass, delay = 50) {
  let lastHoveredItem = null;
  const items = document.querySelectorAll(selector);
  items.forEach(item => {
    item.addEventListener('mouseenter', function() {
      if (lastHoveredItem) {
        setTimeout(() => {
          lastHoveredItem.classList.remove(hoverClass);
        }, delay);
      }
      setTimeout(() => {
        this.classList.add(hoverClass);
        lastHoveredItem = this;
      }, delay);
    });
  });
}
applyHoverEffect('.co-regen-section-6-left-img', 'co-hovered', 50);
applyHoverEffect('.co-regen-section-6-right-img', 'co-hovered', 50);
// ========================================================================================================== SECTION 7
// ===================================================== REUSABLE MARQUEE FUNCTION
function coInitializeTickerCarousel({ 
  selector = '', 
  tickerSpeed = 1, 
  prevNextButtons = true,
  rightScroll = false 
}) {
  let flickity = null;
  let isPaused = false;
  const slideshowEl = document.querySelector(selector);
  if (!slideshowEl) {
    console.error(`Element with selector "${selector}" not found.`);
    return;
  }
  const update = () => {
    if (isPaused) return;
    if (flickity.slides) {
      const direction = rightScroll ? tickerSpeed : -tickerSpeed;
      flickity.x = (flickity.x + direction) % flickity.slideableWidth;
      flickity.selectedIndex = flickity.dragEndRestingSelect();
      flickity.updateSelectedSlide();
      flickity.settle(flickity.x);
    }
    window.requestAnimationFrame(update);
  };
  const pause = () => {
    isPaused = true;
  };
  const play = () => {
    if (isPaused) {
      isPaused = false;
      window.requestAnimationFrame(update);
    }
  };
  flickity = new Flickity(slideshowEl, {
    autoPlay: false,
    pageDots: false,
    draggable: true,
    prevNextButtons: prevNextButtons,
    wrapAround: true,
    selectedAttraction: 0.015,
    friction: 0.25
  });
  flickity.x = 0;
  slideshowEl.addEventListener('mouseenter', pause, false);
  slideshowEl.addEventListener('focusin', pause, false);
  slideshowEl.addEventListener('mouseleave', play, false);
  slideshowEl.addEventListener('focusout', play, false);
  flickity.on('dragStart', () => {
    isPaused = true;
  });
  update();
}
// ===================================================== MARQUEE
coInitializeTickerCarousel({ selector: '.co-regen-section-7-slider', tickerSpeed: 1, prevNextButtons: true, rightScroll: false });
// ========================================================================================================== SECTION 8
let coRegen8Groups = gsap.utils.toArray(".co-regen-section-8-accordion-group");
let coRegen8Menus = gsap.utils.toArray(".co-regen-section-8-accordion-menu");
let coRegen8MenuToggles = coRegen8Groups.map(createAnimation);
coRegen8Menus.forEach((menu) => {
  menu.addEventListener("click", () => coRegen8ToggleMenu(menu));
});
function coRegen8ToggleMenu(clickedMenu) {
  coRegen8MenuToggles.forEach((toggleFn) => toggleFn(clickedMenu));
}
function createAnimation(element) {
  let menu = element.querySelector(".co-regen-section-8-accordion-menu");
  let box = element.querySelector(".co-regen-section-8-accordion-content");
  let minusElement = element.querySelector(".co-regen-section-8-accordion-open");
  let plusElement = element.querySelector(".co-regen-section-8-accordion-close");
  gsap.set(box, { height: "auto" });
  let animation = gsap
    .timeline()
    .from(box, {
      height: 0,
      duration: 0.3,
      ease: "power2.inOut"
    })
    .from(minusElement, { duration: 0.1, autoAlpha: 0, ease:"none" }, 0)
    .to(plusElement, { duration: 0.1, autoAlpha: 0, ease:"none" }, 0)
    .reverse();

  return function (clickedMenu) {
    if (clickedMenu === menu) {
      animation.reversed(!animation.reversed());
    } else {
      animation.reverse();
    }
  };
}
// coRegen8ToggleMenu(coRegen8Menus[0])
// ========================================================================================================== SECTION 9
coMM.add("(min-width: 750px)", () => {
  gsap.set('.co-regen-section-9-wheel-frame', { scale: 0.25 });
  gsap.to('.co-regen-section-9-wheel-frame', {
    scrollTrigger: {
      // markers: true,
      trigger: '.co-regen-section-9',
      start: "top bottom",
      end: "bottom top",
      scrub: 1
    },
    scale: 1,
    rotate: 180
  });
  gsap.set('.co-regen-section-9-item img', { scale: 0.9 });
  gsap.to('.co-regen-section-9-item img', {
    scrollTrigger: {
      // markers: true,
      trigger: '.co-regen-section-9',
      start: "top bottom",
      end: "bottom top",
      scrub: 1
    },
    scale: 1,
    rotate: -180
  });
  gsap.to('.co-regen-section-9-center-image', {
    scrollTrigger: {
      // markers: true,
      trigger: '.co-regen-section-9',
      start: "top bottom",
      end: "bottom top",
      scrub: 1
    },
    rotate: -180
  });
});
coMM.add("(max-width: 749px)", () => {
  gsap.set('.co-regen-section-9-wheel-frame', { scale: 0.5 });
  gsap.to('.co-regen-section-9-wheel-frame', {
    scrollTrigger: {
      // markers: true,
      trigger: '.co-regen-section-9',
      start: "top bottom",
      end: "bottom top",
      scrub: 1
    },
    scale: 1.15,
    rotate: 180
  });
  gsap.set('.co-regen-section-9-item img', { scale: 0.9 });
  gsap.to('.co-regen-section-9-item img', {
    scrollTrigger: {
      // markers: true,
      trigger: '.co-regen-section-9',
      start: "top bottom",
      end: "bottom top",
      scrub: 1
    },
    scale: 1,
    rotate: -180
  });
  gsap.to('.co-regen-section-9-center-image', {
    scrollTrigger: {
      // markers: true,
      trigger: '.co-regen-section-9',
      start: "top bottom",
      end: "bottom top",
      scrub: 1
    },
    rotate: -180
  });
});
